import { FC } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import { useApplicationDocs } from '~/core/shared/api/middle-office/application';
import { DocStatusEnum } from '~/core/shared/constants';
import { createFilterParams } from '~/core/shared/utils/queries';

type DocsTabItemProps = {
  uuid: string;
  definition: string;
};

const uncheckedDocsParams = createFilterParams({
  internal: 'false',
  status: DocStatusEnum.Unchecked,
});

export const DocsTabItem: FC<DocsTabItemProps> = ({ uuid, definition }) => {
  const { meta } = useApplicationDocs(uuid, definition, uncheckedDocsParams);

  const docsTotal = meta?.total ?? 0;

  return (
    <>
      <Box as="span">Docs</Box>

      {docsTotal > 0 && (
        <Flex
          alignItems="center"
          as="span"
          bg="primary.500"
          borderRadius="full"
          boxSize={6}
          color="white"
          fontWeight="bold"
          justifyContent="center"
          ml={1.5}
        >
          {docsTotal}
        </Flex>
      )}
    </>
  );
};
